import React from "react";
import { connect } from "react-redux";
import {
  callAuthCalcPostDateV2,
  clearAuthRecurringValidation,
  callAuthSubmitAchPayment,
} from "../../../actions/authPayment.actions";
import { searchForInstitution } from "../../../actions/achInstitution.actions";
import { AuthPaymentRecurringAchOpenEnd } from "../payment-forms/auth-payment-recurring-ach-open-end.component";
import { AuthRecurringOpenEndReview } from "../review/auth-recurring-open-end-review-fields.component";
import { AuthPaymentRecurringOpenEndSummary } from "../summary/auth-payment-recurring-open-end-summary.component";
import { usd } from "../../../utils/utils";
import { removeSpecialCharacters } from "../../../utils/utils";
import moment from "moment";
import { constructRecurringRequest } from "../misc/recurring-utils";

const RecurringAchOpenEndFlowComponent = (props) => {
  const currentForm = props.form["AuthPaymentRecurringAchOpenEnd"];
  const paymentResponse = props.authPayment.paymentResponse;
  const { setProcessStep, processStep, selectedLoan, backToLoans } = props;

  switch (processStep) {
    case 1:
      return (
        <AuthPaymentRecurringAchOpenEnd
          {...props.authPayment.selectedLoanAdditionalDetails}
          setProcessStep={setProcessStep}
          selectedLoan={selectedLoan}
          authPayment={props.authPayment}
          thisForm={currentForm}
          achInstitution={props.achInstitution}
          callAuthCalcPostDateV2={props.callAuthCalcPostDateV2}
          clearAuthRecurringValidation={props.clearAuthRecurringValidation}
          searchForInstitution={props.searchForInstitution}
          backToLoans={backToLoans}
        />
      );
    case 2:
      return (
        <AuthRecurringOpenEndReview
          openEndPaymentType={currentForm.values.OpenEndPaymentType}
          firstPaymentDate={moment(currentForm.values.PaymentDate).format("MM/DD/YYYY")}
          paymentFrequency={currentForm.values.PaymentFrequency}
          paymentAccount={currentForm.values.AccountNumber.slice(-4)}
          paymentAmount={usd.format(removeSpecialCharacters(currentForm.values.Amount))}
          selectedLoan={selectedLoan}
          continue={() => setProcessStep(3)}
          paymentResponse={paymentResponse}
          callAuthSubmitPayment={() => {
            const paymentDetails = constructRecurringRequest(currentForm.values);    
            props.callAuthSubmitAchPayment(paymentDetails);
          }}
          backToLoans={backToLoans}
          isInternalTransfer={false}
        />
      );
    case 3:
      return (
        <AuthPaymentRecurringOpenEndSummary
          openEndPaymentType={paymentResponse.RecurringPaymentType}
          firstPaymentDate={moment(paymentResponse.PaymentDate).format("MM/DD/YYYY")}
          paymentFrequency={paymentResponse.Frequency}
          paymentAccount={paymentResponse.CardNumberLastFour}
          paymentAmount={usd.format(paymentResponse.PaymentAmount)}
          confirmationEmail={paymentResponse.EmailAddress}
          selectedLoan={selectedLoan}
          backToLoans={backToLoans}
        />
      );
    case 4:
      return <div>Step 4</div>;
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callAuthCalcPostDateV2,
  clearAuthRecurringValidation,
  callAuthSubmitAchPayment,
  searchForInstitution,
};

const RecurringAchOpenEndFlow = connect(null, mapDispatchToProps)(RecurringAchOpenEndFlowComponent);

export default RecurringAchOpenEndFlow;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/flow-components/recurring-ach-open-end-flow.component.js